import React from 'react';

import styles from './TariffHeader.module.scss';

interface TariffHeaderProps {
    name: string;
    period: string;
}

const TariffHeader: React.FC<TariffHeaderProps> = ({ name, period }) => (
    <div className={styles.header}>
        <div className={styles.title}>{name}</div>
        <div className={styles.period}>{period}</div>
    </div>
);

export default TariffHeader;
